export enum ForumsPathsEnum {
  ROOT = "forums",
}

export enum ForumsRoutesEnum {
  ROOT = "/forums",
}
